// The Add-to-Home-Screen instructions, shared everywhere they're needed so a
// member never sees two versions of the same steps.
//
// Written plainly on purpose. The step people miss is the last one: the icon
// they just made IS the app, and it's the only version that can notify them.
// Saying "add to home screen" without saying that leaves people opening the
// league in Safari forever and wondering why nothing ever pings them.
export function InstallSteps() {
  return (
    <ol className="steps">
      <li>Tap the <b>Share</b> button at the bottom of the screen. It's the square with an arrow pointing up. ↑</li>
      <li>Scroll down the list and tap <b>Add to Home Screen</b>.</li>
      <li>Tap <b>Add</b> in the top right corner.</li>
      <li>Now look at your home screen. There's a new <b>How Y&apos;all Been</b> icon sitting there, just like a regular app.</li>
      <li>Close this browser. From now on, open How Y&apos;all Been by tapping that icon.</li>
    </ol>
  );
}

// The "why does this matter" line that goes with the steps.
export function InstallWhy() {
  return (
    <p className="muted">
      That icon <b>is</b> the app. It's the only version that can ping your phone when questions drop.
      If you keep opening the league in your browser, you won't get those pings and you'll miss drops.
    </p>
  );
}
